import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Page } from '../components/ui/Page';
import { usePageTitle } from '../hooks/usePageTitle';

function ApiKeyLoginForm() {
  const { loginWithBypassToken } = useAuth();
  const [email, setEmail] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await loginWithBypassToken(email, apiKey);
      window.location.href = '/';
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <Input label="Email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
      <Input label="API key" type="password" autoComplete="current-password" value={apiKey} onChange={(e) => setApiKey(e.target.value)} required error={error || undefined} />
      <Button type="submit" variant="secondary" fullWidth loading={loading}>
        Sign in with API key
      </Button>
    </form>
  );
}

/** Signed-out landing: one sentence, the Microsoft sign-in, and the API-key fallback behind a disclosure. */
export function Landing() {
  const { login } = useAuth();
  usePageTitle('Sign in');
  return (
    <Page width="narrow" className="py-16 text-center">
      <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100">Tasky</h1>
      <p className="mx-auto mt-3 max-w-md text-lg text-gray-600 dark:text-gray-400">
        Tasks, projects and KPIs for the APTC team, in one place.
      </p>
      <div className="mt-8">
        <Button size="lg" onClick={() => login()}>
          Sign in with Microsoft
        </Button>
      </div>
      <details className="mx-auto mt-10 max-w-sm rounded-lg bg-white p-5 text-left shadow dark:bg-gray-800">
        <summary className="cursor-pointer text-sm font-medium text-gray-600 dark:text-gray-300">Sign in with an API key instead</summary>
        <div className="mt-4">
          <ApiKeyLoginForm />
        </div>
      </details>
    </Page>
  );
}
